import { Component } from '@angular/core'

@Component({
  selector: 'app-overview-expert-loader',
  template: `
    <div class="container">
      <div class="columns flex flex-wrap">
        <div class="column is-6-mobile is-4-tablet is-3-desktop">
          <div class="lc lc--author lc--white">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div class="column is-6-mobile is-4-tablet is-3-desktop">
          <div class="lc lc--author lc--white">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div class="column is-6-mobile is-4-tablet is-3-desktop">
          <div class="lc lc--author lc--white">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <div class="column is-6-mobile is-4-tablet is-3-desktop">
          <div class="lc lc--author lc--white">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  `,
  standalone: true
})
export class OverviewExpertLoaderComponent {}
